import EuTableLayout from 'pages/EuTableLayout/euTableLayout';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'Store/store';
import { getFEDSAReferenceNumber } from 'utils/common';
import MultiSelect from 'components/SharedLayout/Multiselect/multiSelect';
import InlineMessage from '@ingka/inline-message';
const EuArchived = (props: any) => {
  const {
    queries,
    tabChange,
    handleTabChange,
    setQuery,
    supplierDDSRefNum,
    setSupplierDDSRefNum,
    setSelectedStatus,
    setActiveTab,
    setFedsa_RefNum,
    selectedStatus,
  } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { euArchivedList } = useSelector((state: RootState) => state.euArchivedList);
  const [archivedListData, setArchivedListData] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [noResponse, setNoResponse] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [multiSelectKey, setMultiSelectKey] = useState(0);
  const [selectedSuppliers, setSelectedSuppliers] = useState<string[]>([]);
  const [pdfInlineMessage, setPDFInlineMessage] = useState('');
  const [previousStatus, setPreviousStatus] = useState('');

  const mapping = {
    supplierName: 'Supplier Name',
    article_number: 'Supplier Article Number',
    supplierDDSRefNum: 'Supplier_DDS_Ref_Num',
    receivedOn: 'DDS Received On',
    fedsaStatus: 'Current status',
    supplierRefNum: 'Supplier Ref_Num',
    pdf: 'PDF',
    url: 'Link to IKEA DDS',
    fedsa_RefNum: '__Ref_Num',
  };
  useEffect(() => {
    if (supplierDDSRefNum && selectedStatus === 'Supplier') {
      setQuery(supplierDDSRefNum);
      onSearch(supplierDDSRefNum);
      setHasSearched(true);
    }
  }, [supplierDDSRefNum, selectedStatus]);
  useEffect(() => {
    if (selectedStatus !== 'Supplier') {
      setSupplierDDSRefNum('');
      setQuery('');
      setHasSearched(false);
      setFilteredData([]);
      setArchivedListData([]);
      setNoResponse(false);
    }
  }, [selectedStatus]);

  useEffect(() => {
    if (queries === supplierDDSRefNum) {
      onSearch(queries);
      setHasSearched(true);
    }
  }, [queries]);
  useEffect(() => {
    if (hasSearched && selectedStatus !== previousStatus) {
      setHasSearched(false);
      setQuery('');
      setFilteredData([]);
      setArchivedListData([]);
      setNoResponse(false);
      setSupplierDDSRefNum('');
      setFedsa_RefNum('');
    }

    setPreviousStatus(selectedStatus);
  }, [selectedStatus]);

  useEffect(() => {
    const items = mappedItems(euArchivedList, mapping);
    if (!queries || queries.trim().length === 0) {
      setArchivedListData(items);
      setFilteredData(items);

      if (!hasSearched) {
        setNoResponse(false);
      }

      setHasSearched(false);
    } else {
      const trimmedQuery = queries.trim().toLowerCase();
      const filteredItems = items.filter(
        (item) =>
          item['Supplier Name']?.toLowerCase().includes(trimmedQuery) ||
          item['Supplier Article Number']?.toLowerCase().includes(trimmedQuery) ||
          item['GTIN']?.toLowerCase().includes(trimmedQuery) ||
          // item['Trade Item Description']?.toLowerCase().includes(trimmedQuery) ||
          item['Supplier_DDS_Ref_Num']?.toLowerCase() === trimmedQuery ||
          item['__fullRefNum']?.toLowerCase().includes(trimmedQuery) ||
          item['Supplier Ref_Num']?.toLowerCase().includes(trimmedQuery)
      );
      setArchivedListData(filteredItems);
      setFilteredData(filteredItems);
      setNoResponse(filteredItems?.length === 0);
      setHasSearched(true);
    }
  }, [euArchivedList, queries]);

  useEffect(() => {
    if (!queries || !hasSearched) return;

    const trimmedQuery = queries.trim().toLowerCase();
    const items = mappedItems(euArchivedList, mapping);

    const filteredItems = items.filter(
      (item) =>
        item['Supplier Name']?.toLowerCase().includes(trimmedQuery) ||
        item['Supplier Article Number']?.toLowerCase().includes(trimmedQuery) ||
        item['DDS Ref_Num']?.toLowerCase().includes(trimmedQuery) ||
        item['GTIN']?.toLowerCase().includes(trimmedQuery) ||
        item['Trade Item Description']?.toLowerCase().includes(trimmedQuery) ||
        item['Supplier_DDS_Ref_Num']?.toLowerCase() === trimmedQuery ||
        item['__fullRefNum']?.toLowerCase().includes(trimmedQuery) ||
        item['Supplier Ref_Num']?.toLowerCase().includes(trimmedQuery)
    );

    setArchivedListData(filteredItems);
    setFilteredData(filteredItems);
    setNoResponse(filteredItems.length === 0);
  }, [queries, hasSearched]);

  useEffect(() => {
    setMultiSelectKey((prev) => prev + 1);
  }, [tabChange]);

  const mappedItems = (itemList, mappingKey) => {
    if (!Array.isArray(itemList)) return [];

    return itemList.map((item) => {
      return Object.keys(mappingKey).reduce((acc, key) => {
        const mappedKey = mappingKey[key];

        if (key === 'Supplier Ref_Num' && item[key]) {
          acc[mappedKey] = item[key].toString().slice(0, 5) + '...';
          acc['__fullRefNum'] = item[key];
        } else {
          acc[mappedKey] = item[key] !== undefined ? item[key] : null;
        }

        return acc;
      }, {});
    });
  };

  const getFilterData = (data) => {
    const uniqueNames = Array?.from(
      new Set(data?.map((item) => item['supplierName']).filter((name) => name))
    );
    return uniqueNames;
  };
  const comboFilter = (list) => {
    if (!list?.length) {
      setArchivedListData(filteredData); // Use already filtered data
      return;
    }

    const data = filteredData?.filter((item) => list.includes(item['Supplier Name']));

    setArchivedListData(data);
    setNoResponse(data.length === 0);
  };

  const onSearch = (searchQuery) => {
    if (searchQuery === '' && queries === '') return;
    setQuery(searchQuery);
    setHasSearched(true);
  };

  return (
    <div className="details-container">
      <div className="table-container">
        <div style={{ paddingTop: '8px' }}>
          <div style={{ width: '25%' }}>
            <MultiSelect
              key={multiSelectKey}
              item={getFilterData(euArchivedList)}
              comboFilter={comboFilter}
              tabChange={tabChange}
            />
          </div>

          {euArchivedList?.length === 0 ? (
            <div className="no-response">
              <p>No data available</p>
            </div>
          ) : archivedListData?.length > 0 ? (
            <EuTableLayout
              items={archivedListData}
              isLeftSide={true}
              euPendingApprovalData={euArchivedList}
              tabChange={tabChange}
              onSearch={onSearch}
              setSupplierDDSRefNum={setSupplierDDSRefNum}
              setSelectedStatus={setSelectedStatus}
              handleTabChange={handleTabChange}
              showRefNum={true}
              setHasSearched={setHasSearched}
              pdfInlineMessage={pdfInlineMessage}
              setPDFInlineMessage={setPDFInlineMessage}
              setActiveTab={setActiveTab}
              setFedsa_RefNum={setFedsa_RefNum}
              selectedStatus={selectedStatus}
            />
          ) : hasSearched && noResponse ? (
            <div className="no-response">
              <p>0 results found</p>
            </div>
          ) : null}

          {pdfInlineMessage && (
            <InlineMessage
              body={pdfInlineMessage}
              link=""
              linkLabel=""
              title="Notification"
              variant="negative"
              dismissable
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EuArchived;
